import styled from 'styled-components';
import {MAIN_COLOR} from "../../../components/globalThemes";

export const CategoryDiv = styled.a`
    width: 200px;
    height: 200px;
    background-color: ${({color}) => color};
    border-radius: 25px;
    border: 1px solid ${MAIN_COLOR + 90};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    text-decoration: none;
    margin: 30px;

    &:hover {
        transform: scale(1.05);
    }
`;

export const CategoryTitle = styled.p`
    flex: 1;
    font-family: Roboto Condensed, serif;
    color: white;
    font-size: 14px;
    width: 80%;
    text-align: center;
    white-space: pre-wrap;
    line-height: 1.5;
`;

export const CategoryInfo = styled.p`
    font-family: BlenderProBold, serif;
    color: white;
    font-size: 22px;
    margin: 0;
    padding: 50px;
    text-align: center;
`;

export const CategoryArrow = styled.p`
    color: white;
    width: 80%;
    text-align: center;
    position: absolute;
    bottom: -7px;
    
    &:after {
        content: '<';
        font-family: Roboto Condensed, serif;
        font-weight: bold;
        font-size: 18px;
        display: inline-block;
        transform: rotate(270deg);
    }
`;

export const IconWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    margin-top: 30px; 
`;
